import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PLWEB_ORIGIN } from "../lib/plweb";
import "./InvoiceRedirect.css";

/**
 * `https://pl.eeighttech.com/view?guid=…` → the web app's viewer, query intact.
 *
 * The service's share links mint the web app's host, so in principle nothing
 * reaches this route. It exists because the base URL is a deployment setting:
 * pointed at this host — as it was before the viewer moved — every texted invoice
 * and receipt link would land on a path this site does not serve, which React
 * Router answers with a blank page. Forwarding costs one line and turns that
 * misconfiguration into a working link.
 */
export default function ViewRedirect() {
	const { search } = useLocation();
	const target = `${PLWEB_ORIGIN}/view${search}`;

	useEffect(() => {
		window.location.replace(target);
	}, [target]);

	return (
		<main className="invoice-redirect">
			<p>
				Opening your document… <a href={target}>Continue</a>
			</p>
		</main>
	);
}
